export const TRANSLATIONS_EN = {
 "header.home" : "Home" ,
 "header.admin.signUp": "Sign Up",
 "footer.contactUs": "Contact Us",
 "page.endDate": "End Date",
 "page.login": "Login",
 "page.email": "Email",
 "page.address1": "Address Line1",
 "page.address2": "Address Line2",
 "page.city": "City",
 "page.country": "Country",
 "page.state": "State",
 "page.zipCode": "Zip Code",
 "page.zipExt": "Zip Extn",
 "page.phone": "Phone",
 "page.manageMFA.token":"Token is required.",
 "page.MFAModel.header":"Provide Multi-factor authentication token from Authenticator App",
 "page.MFAModel.token":"Token",
 "page.MFAModel.reset":"Reset Multi-factor Auth",
 "page.forgotPasswd.toResetPassword":"To reset the password",
 "page.forgotPasswd.step1":"1. Request for a verification code which will be sent to your email id.",
 "page.forgotPasswd.step2":"2. Input the verification code received along with the new password in the fields below and submit the request.",
 "page.forgotPasswd.step1.1":"Step 1. Provide the registered email id to generate a verification code.",
 "page.forgotPasswd.step1.2":"Please check your email for the verification code after you submit the request.",
 "page.forgotPasswd.step2.1":"Step 2. Input the emailed verification code and new password in the fields below and submit the request.",
 "page.forgotPasswd.verificationCode":"Verification Code",
 "page.verification.verifyAccount":"Verify your Account",
 "page.verification.checkEmail":"Please check your registered email for the verification code.",
 "page.resendCode.resend":"Resend Verification Code",
 "page.login.forgotPassword":"Forgot Password",
 "page.company": "Company",
 "page.firstName": "First Name",
 "page.lastName": "Last Name",
 "page.submit": "Submit",
 "page.cancel": "Cancel",
 "page.password": "Password",
 "page.confirmationMessage": "Are you sure?",
 
 "error.MFATokenError": "Error!! Multi-factor Authentication token provided is not valid.",
 "error.getCountryFailed":"Error!! Country list was not retrieved",
 "error.getCountryAnswersFailed":"Error!! Country details was not retrieved",
 "error.getFoodGroupFailed":"Error!! Food Groups was not retrieved",
 "error.getFoodFailed":"Error!! Food list was not retrieved",
 "error.getFoodAnswersFailed":"Error!! Food details was not retrieved",
 "error.error":"Error!!",
 "error.userAuthFailed":"User Authentication Failed.",
 "error.emailReqd":"Email is required.",
 "error.invalidEmail":"Please provide a valid email id!",
 "error.passwdReqd":"Password is required.",
 "error.weakPassword":"Please choose a strong password with minimum 8 characters, a number and a special character!",
 "error.MFAAuthFailed": "Error!! Multi-factor Authentication failed ",
 "error.MFAStateError": "Error!! There was error in changing the MFA state.",
 "error.passwdMatchFailed":"Passwords doesn't match!",
 "error.termsUpdateFailed": "Error!! Terms and condition update failed.",
 "error.retypePasswdReqd":"Retype Password is required!",
 "error.sendCodeError":"Error!! Sending verification code for resetting the password failed. Please try again later",
 "error.codeReqd":"Verification Code is required.",
 "error.verificationFailed":"Error!! Verification failed. Please try again later",
 "error.changePasswordFailed":"Error!! Password change failed. Please try again later",
 "error.resendVerificationFailed":"Error!! Resend verification code failed. Please try again later",
 "error.userNameReqd":"Username is required.",
 "error.firstNameReqd":"First name is required.",
 "error.lastNameReqd":"Last name is required.",
 "error.compNameReqd":"Company name is required.",
 "error.stateReqd":"State is required.",
 "error.userEditFailed":"Customer information was not updated",
 "error.addUserFailed":"Add user failed.",
 "error.getStateFailed":"State list was not retrieved",
 "error.phoneReqd":"Phone is required.",
 "error.sessionTimeout":"Session has timed out. Please login again.",
 "error.getTermsFailed":"Term was not retrieved.",
 "error.logoutFailed":"Logout Failed.",
};